export const getToken = () => localStorage.getItem("@ps-credentials");

export const removeToken = () => localStorage.removeItem("@ps-credentials");

export const setToken = (token: string) =>
  localStorage.setItem("@ps-credentials", token);
